import { context } from 'modules/App/Router/Providers/Auth/AccessToken'
import { useContext } from 'react'

const useAccessToken = () => useContext(context)

export { useAccessToken }
